import { Container, Stack } from "@mui/material"
import { useState } from "react";
import { Button } from "src/@/components/ui/button"
import { Tabs, TabsList, TabsTrigger, TabsContent } from "src/@/components/ui/tabs";

import { HeaderPageComponentConfig } from "src/components/_dashboard/configuracoes";


const CharacterQuota = () => {
  return (
    <div className="bg-slate-100 p-4 rounded-md w-full">
      <div className="text-sm font-medium text-gray-500">Tokens de texto</div>
      <div className="flex justify-between items-center mt-2">
        <div className="text-gray-800">
        <div>Total</div>
          <div>Gasto</div>
          <div>Restantes</div>
        </div>
        <div className="text-right">
          <div className="text-lg font-semibold text-gray-800">10000</div>
          <div className="text-lg font-semibold text-gray-800">29,563</div>
          <div className="text-lg font-semibold text-gray-800">2200</div>

        </div>
      </div>
      <div className="flex items-center mt-4">
        <div className="flex-grow bg-gray-300 h-2 rounded-full">
          <div className="bg-violet-900 h-2 rounded-full" style={{ width: '1%' }}></div>
        </div>
        <div className="text-gray-500 ml-2">1%</div>
      </div>

    </div>
  );
};

const CharacterQuotaAudio = () => {
  return (
    <div className="bg-slate-100 p-4 rounded-md w-full">
      <div className="text-sm font-medium text-gray-500">Tokens de audio</div>
      <div className="flex justify-between items-center mt-2">
        <div className="text-gray-800">
          <div>Total</div>
          <div>Gasto</div>
          <div>Restantes</div>
        </div>
        <div className="text-right">
          <div className="text-lg font-semibold text-gray-800">3000</div>
          <div className="text-lg font-semibold text-gray-800">800</div>
          <div className="text-lg font-semibold text-gray-800">2200</div>
        </div>
      </div>
      <div className="flex items-center mt-4">
        <div className="flex-grow bg-gray-300 h-2 rounded-full">
          <div className="bg-violet-900 h-2 rounded-full" style={{ width: '30%' }}></div>
        </div>
        <div className="text-gray-500 ml-2">30%</div>
      </div>

    </div>
  );
};


export function ConsumoComponent() {
  const [selectedTab, setSelectedTab] = useState("aiCredits");
  return (
    <Container>
      <HeaderPageComponentConfig
        titulo="Consumo"
      />
      <div className="mt-5">
      <Tabs value={selectedTab} onValueChange={setSelectedTab} className="w-full">
      <TabsList className="flex space-x-2">
        <TabsTrigger value="aiCredits">AI Credits</TabsTrigger>
        <TabsTrigger value="automations">Automations</TabsTrigger>
        <TabsTrigger value="apiCalls">API Calls</TabsTrigger>
        <TabsTrigger value="users">Users</TabsTrigger>
      </TabsList>

      {/* Conteúdo de AI Credits */}
      <TabsContent value="aiCredits">
        <div className="p-4">
          <h2 className="text-lg font-bold">Créditos de IA processados</h2>
          <p className="mt-2">Não há créditos de IA contratados.</p>
          <div className="grid grid-cols-3 gap-4 mt-4">
            <div className="p-4 bg-gray-100 rounded">
              <h3 className="text-sm font-semibold">Automação</h3>
              <p className="text-2xl">0</p>
            </div>
            <div className="p-4 bg-gray-100 rounded">
              <h3 className="text-sm font-semibold">Agents</h3>
              <p>Em breve</p>
            </div>
            <div className="p-4 bg-gray-100 rounded">
              <h3 className="text-sm font-semibold">Copilot</h3>
              <p>Em breve</p>
            </div>
          </div>
        </div>
      </TabsContent>

      {/* Conteúdo de Automations */}
      <TabsContent value="automations">
        <div className="p-4">
          <h2 className="text-lg font-bold">Tarefas processadas este mês</h2>
          <p className="mt-2">0</p>
          <h3 className="mt-4 text-md font-semibold">Visão geral</h3>
          <p className="text-sm text-gray-600">1 de jan de 2025 - 7 de jan de 2025</p>
          <h3 className="mt-4 text-md font-semibold">Detalhes das automações</h3>
          <div className="mt-4">
            <input
              type="text"
              placeholder="Buscar automações"
              className="w-full p-2 border rounded"
            />
            <div className="flex justify-between mt-2 text-sm text-gray-600">
              <span>Tags: Todas</span>
              <span>Pipes: Todos</span>
              <span>Status: Todos</span>
              <span>Eventos: Todos</span>
              <span>Ações: Todos</span>
            </div>
          </div>
          <div className="mt-4 border-t pt-4">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-gray-600">
                  <th>Automação</th>
                  <th>Tags</th>
                  <th>Tarefas processadas</th>
                  <th>Status</th>
                  <th>Pipe de origem</th>
                  <th>Evento</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan="6" className="text-center text-gray-600 py-4">
                    Não foi possível encontrar nenhum resultado. Tente usar palavras-chave ou filtros diferentes.
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="mt-4 text-sm text-gray-600 text-center">0 automações totais</p>
          </div>
        </div>
      </TabsContent>

      {/* Conteúdo de API Calls */}
      <TabsContent value="apiCalls">
        <div className="p-4">
          <h2 className="text-lg font-bold">Chamadas de API processadas este mês</h2>
          <p className="mt-2">0</p>
        </div>
      </TabsContent>

      {/* Conteúdo de Users */}
      <TabsContent value="users">
        <div className="p-4">
          <h2 className="text-lg font-bold">Usuários</h2>
          <div className="mt-4">
            <p><span className="font-bold">1</span> usuário pago</p>
            <p><span className="font-bold">0</span> usuários gratuitos</p>
          </div>
        </div>
      </TabsContent>
    </Tabs>
      </div>
    </Container>
  )
}
